import { UserMedicineHistoryModel } from './userMedicineHistoryModel';
import { UserMedicineModel } from './userMedicineModel';

export class UserMedicineWithHistoryWrapper {
    userMedicine: UserMedicineModel;
    userMedicineHistory: UserMedicineHistoryModel;
}